import { useLocation, useParams } from 'react-router-dom'
import { useProvider, useMyProviders } from '@/hooks/useProviders'
import { PageHeader } from '@/components/PageHeader'
import ProviderInfo from './ProviderInfo'

export default function ProviderPage() {
  const location = useLocation()
  const params = useParams()
  // 路徑可能是 /admin/provider/create 或 /provider/:provider_id (index/info)
  const isCreateMode = location.pathname.endsWith('/provider/create')
  const urlProviderId = params.provider_id ? Number(params.provider_id) : undefined

  // Get current user's providers (for provider_admin who has implicit provider scope)
  const { providers: myProviders, isLoading: isLoadingMyProviders } = useMyProviders()

  // 決定 provider_id：URL 有就用 URL；沒有就 fallback 到 user 自己的 provider（provider_admin 用）
  const providerId =
    urlProviderId ?? (myProviders && myProviders.length > 0 ? myProviders[0].provider_id : undefined)

  const { provider, isLoading: isLoadingProvider } = useProvider(
    isCreateMode ? null : providerId ?? null,
  )

  const isLoading = isLoadingMyProviders || isLoadingProvider

  const headerLevel = isCreateMode ? 'page' : 'section'
  const title = isCreateMode ? '新增組織' : '組織資訊'
  const description = isCreateMode ? '建立新的組織資訊' : '管理組織資訊和人員'

  return (
    <div className="space-y-6">
      <PageHeader title={title} description={description} level={headerLevel} />

      <ProviderInfo
        provider={provider}
        isLoading={isLoading}
        mode={isCreateMode ? 'create' : 'edit'}
      />
    </div>
  )
}
